import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import React from "react";
import sendRequest from "../../dataProvider/sendRequest";
import formatCurrency from "../../unit/formatCurrency";
import CustomSelect from "../../unit/forms/CustomSelect";
import CustomSummaryCashFlowTable from "./CustomSummaryCashFlowTable";
import CustomSummaryCashOutFlowTable from "./CustomSummaryCashOutFlowTable";
const TableCellRight = styled(TableCell)({
  textAlign: "right",
  fontFamily: "Roboto",
});

const CustomSummaryCashFlow = ({ ...props }) => {
  const userId = props.userId;
  const [weekData, setWeekData] = React.useState<any>({});
  const [dateList, setDateList] = React.useState<any[]>([]);
  const [accountList, setAccountList] = React.useState([]);
  const [accountOptionList, setAccountOptionList] = React.useState<
    { value: any; label: string }[]
  >([]);
  const [showCashFlow, setShowCashFlow] = React.useState(false);
  const [showCashOutFlow, setShowCashOutFlow] = React.useState(false);
  const [searchkey, setSearchKey] = React.useState("");

  React.useEffect(() => {
    const reqUrl = "customers/cashflow";
    sendRequest(reqUrl, {
      id: userId,
      data: {
        select_account_name: searchkey,
      },
    }).then((response) => {
      setAccountList(response.accountList);
      if (response?.accountList) {
        let accountOptionListRec: { value: any; label: string }[] = [];
        for (let key in response.accountList) {
          let accountType = key;
          accountOptionListRec.push({
            value: "type|" + accountType,
            label: accountType,
          });
          let accountList = response.accountList[key];
          accountList.forEach((account: any) => {
            accountOptionListRec.push({
              value: "name|" + account.value,
              label: "-----" + account.label,
            });
          });
        }
        setAccountOptionList(accountOptionListRec);
      }
      if (response?.translation_weekly_data) {
        setWeekData(response.translation_weekly_data);
      }

      if (response?.translation_weekly_data?.cal_month_data) {
        let dateListRec: any[] = [];
        setDateList(response?.translation_weekly_data?.cal_month_data);
      }
    });
  }, [userId, searchkey]);

  if (!weekData) {
    return <div>Loading...</div>;
  }

  const handleSearch = () => {
    setSearchKey(searchkey);
  };

  return (
    <div
      key={"cashflow_" + userId}
      style={{
        width: `100%`,
        maxWidth: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      <Grid
        container
        spacing={2}
        style={{ marginTop: 2, width: "600px", maxWidth: "600px" }}
      >
        <Grid item xs={4}>
          Account Name
        </Grid>
        <Grid item xs={8}>
          <CustomSelect
            name="select_account_name"
            variant="outlined"
            value={searchkey}
            optionlist={accountOptionList}
            onChange={(e) => setSearchKey(e.target.value)}
          />
        </Grid>
      </Grid>
      <Table
        key={"cashflow_table" + userId}
        id="table-customer-summary-cashflow"
        sx={{
          width: "100%",
          "& .MuiTableCell-root": {
            paddingTop: "10px",
            paddingBottom: "10px",
          },

          border: "1px solid #d5d5d5",
          "& .MuiTableCell-head": {
            backgroundColor: "#edf4fb",
            height: "25px",
            maxHeight: "25px",
          },
          "& .MuiTableRow-head": {
            border: "1px solid #d5d5d5",
            backgroundColor: "#edf4fb",
            height: "25px",
            maxHeight: "25px",
          },
          "& TableCell": {
            border: "1px solid #d5d5d5",
          },
          maxWidth: "100%",
        }}
      >
        <TableHead>
          {dateList == undefined || dateList.length == 0 || dateList == null ? (
            <TableRow>
              <TableCell colSpan={8}>No Transaction account </TableCell>
            </TableRow>
          ) : (
            <>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#506070",
                    color: "#000",
                  }}
                ></TableCell>
                {Object.keys(dateList).map((year: any) => {
                  return (
                    <TableCell
                      colSpan={dateList[year].length}
                      key={"cashflow_year_" + year}
                      sx={{
                        backgroundColor: "#506070",
                        color: "#000",
                      }}
                    >
                      {year}
                    </TableCell>
                  );
                })}
                <TableCell
                  sx={{
                    backgroundColor: "#506070",
                    color: "#000",
                  }}
                ></TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#506070",
                    color: "#000",
                  }}
                ></TableCell>
                {Object.keys(dateList).map((year: any) => {
                  return dateList[year].map((week: any) => {
                    return (
                      <TableCell
                        key={"cashflow_week_" + week}
                        sx={{
                          backgroundColor: "#506070",
                          color: "#000",
                        }}
                      >
                        {week}
                      </TableCell>
                    );
                  });
                })}
                <TableCell
                  sx={{
                    backgroundColor: "#506070",
                    color: "#000",
                  }}
                >
                  Total
                </TableCell>
              </TableRow>
            </>
          )}
        </TableHead>
        <TableBody>
          {/* Cash Inflow */}
          {weekData?.translation_main_category_data_total && (
            <TableRow sx={{ backgroundColor: "#919bad" }}>
              <TableCell
                sx={{
                  width: "300px",
                  minWidth: "300px",
                  display: "-webkit-inline-box",
                  height: "43px",
                }}
              >
                {showCashFlow ? (
                  <RemoveCircleIcon
                    onClick={() => setShowCashFlow(!showCashFlow)}
                    sx={{
                      fontSize: "16px",
                      color: "#506070",
                      verticalAlign: "text-top",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <AddCircleIcon
                    onClick={() => setShowCashFlow(!showCashFlow)}
                    sx={{
                      fontSize: "16px",
                      color: "#506070",
                      verticalAlign: "text-top",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                  />
                )}
                Cash Inflow
              </TableCell>
              {Object.entries(
                weekData?.translation_main_category_data_total?.datalist
              ).map(([key, value]) => (
                <TableCellRight key={"cashflow_cell_" + key}>
                  {formatCurrency(value)}
                </TableCellRight>
              ))}
              {/* 如果没有datalist, 则显示空白的 */}
              {weekData?.translation_main_category_data_total?.datalist &&
                Object.entries(
                  weekData?.translation_main_category_data_total?.datalist
                ).length == 0 && <TableCell colSpan={12}></TableCell>}
              <TableCellRight>
                {formatCurrency(
                  weekData?.translation_main_category_data_total?.total
                )}
              </TableCellRight>
            </TableRow>
          )}

          {/* 循环显示 translation_main_category_data*/}
          {showCashFlow &&
            weekData?.translation_main_category_data &&
            Object.entries(weekData?.translation_main_category_data).map(
              ([key, value]) => (
                <CustomSummaryCashFlowTable
                  key={key}
                  value={value}
                  dateList={dateList}
                />
              )
            )}

          {/* Cash Outflow */}
          {/* translation_main_category_data_total_zhichu */}
          {weekData?.translation_main_category_data_total_zhichu && (
            <TableRow sx={{ backgroundColor: "#919bad" }}>
              <TableCell
                sx={{
                  width: "300px",
                  minWidth: "300px",
                  display: "-webkit-inline-box",
                  height: "43px",
                }}
              >
                {showCashOutFlow ? (
                  <RemoveCircleIcon
                    onClick={() => setShowCashOutFlow(!showCashOutFlow)}
                    sx={{
                      fontSize: "16px",
                      color: "#506070",
                      verticalAlign: "text-top",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <AddCircleIcon
                    onClick={() => setShowCashOutFlow(!showCashOutFlow)}
                    sx={{
                      fontSize: "16px",
                      color: "#506070",
                      verticalAlign: "text-top",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                  />
                )}
                Cash Outflow
              </TableCell>
              {Object.entries(
                weekData?.translation_main_category_data_total_zhichu?.datalist
              ).map(([key, value]) => (
                <TableCellRight key={"cashflow_cell_" + key}>
                  {formatCurrency(value)}
                </TableCellRight>
              ))}
              {/* 如果没有datalist, 则显示空白的 */}
              {weekData?.translation_main_category_data_total_zhichu
                ?.datalist &&
                Object.entries(
                  weekData?.translation_main_category_data_total_zhichu
                    ?.datalist
                ).length == 0 && <TableCell colSpan={12}></TableCell>}
              <TableCellRight>
                {formatCurrency(
                  weekData?.translation_main_category_data_total_zhichu?.total
                )}
              </TableCellRight>
            </TableRow>
          )}

          {/* 循环显示 translation_main_category_data_zhichu*/}
          {showCashOutFlow &&
            weekData?.translation_main_category_data_zhichu &&
            Object.entries(weekData?.translation_main_category_data_zhichu).map(
              ([key, value]) => (
                <CustomSummaryCashOutFlowTable
                  key={key}
                  value={value}
                  dateList={dateList}
                />
              )
            )}

          {/* translation_total_data datalist, total */}
          {weekData?.translation_total_data && (
            <TableRow sx={{}}>
              <TableCell
                sx={{
                  width: "300px",
                  display: "-webkit-inline-box",
                  height: "43px",
                }}
              >
                Total
              </TableCell>
              {Object.entries(weekData?.translation_total_data?.datalist).map(
                ([key, value]) => (
                  <TableCellRight
                    key={"cashflow_cell_" + key}
                    sx={{
                      color: value < 0 ? "red" : "black",
                    }}
                  >
                    {formatCurrency(value)}
                  </TableCellRight>
                )
              )}
              <TableCellRight
                sx={{
                  color:
                    weekData?.translation_total_data?.total < 0
                      ? "red"
                      : "black",
                }}
              >
                {formatCurrency(weekData?.translation_total_data?.total)}
              </TableCellRight>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default CustomSummaryCashFlow;
